export default __webpack_public_path__ + "locales/sr-Cyrl-RS/JavascriptSdk.json?hash=4b188bddbf434193862d919f4e6faadf";